import { gql } from 'graphql-request'

export const UN_BAN_USER = gql`
  query UnbanUser($userId: Float!) {
    unbanUser(userId: $userId) {
      message
    }
  }
`
